var BlockImg = Object.getPrototypeOf(app).BlockImg = new Component("block-img");
BlockImg.debug = false;
BlockImg.createdAt      = "1.0.0";
BlockImg.lastUpdate     = "1.4.14";
BlockImg.version        = "1.0.1";



// WEBPACK FOOTER //
// ./src/components/block-img/block-img.js